import styled from 'styled-components';
import LoadingSpinner from '../../../components/LoadingSpinner';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  z-index: 1000;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.special.shadow};
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
`;

const Message = styled.p`
  font-size: 16px;
  font-weight: 500;
  color: ${({ theme }) => theme.text.secondary};
  margin: 0;
`;

const LoadingModal = ({ message }) => {
  return (
    <Container>
      <LoadingSpinner />
      {message && <Message>{message}</Message>}
    </Container>
  );
};

export default LoadingModal;
